import { render, staticRenderFns } from "./AdminEditableCoownersList.vue?vue&type=template&id=6c970ce4"
import script from "./AdminEditableCoownersList.vue?vue&type=script&lang=ts"
export * from "./AdminEditableCoownersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports